import { Map, OrderedSet } from 'immutable';

import { TEST_ERRORS_PER_PAGE } from '../../../constants';

export const createTestErrorReducers = (types) => {
  const initialState = Map({
    errorCountByDate: OrderedSet(),
    aggregatedErrors: OrderedSet(),
    aggregatedErrorsTotal: 0,
    totalErrorCounts: 0,
    testsByError: Map(),
    pagination: Map({
      current: 1,
      perPage: TEST_ERRORS_PER_PAGE,
    }),
  });

  const reducer = (state = initialState, { type, payload, error, meta }) => {
    switch (type) {
      case types.GET_TEST_TRENDS.SUCCESS:
        return state.withMutations((newState) => {
          const errors = payload.buckets.map((bucket) => {
            const [{ count = 0 }] = bucket.aggs.errorMessage;
            return { name: bucket.datetime, errorCount: count };
          });
          newState.set('errorCountByDate', OrderedSet(errors));
        });
      case types.GET_AGGREGATED_TEST_ERRORS.REQUEST:
        return state.withMutations((newState) => {
          newState
            .set('aggregatedErrors', initialState.get('aggregatedErrors'))
            .set('totalErrorCounts', initialState.get('totalErrorCounts'));
        });
      case types.GET_AGGREGATED_TEST_ERRORS.SUCCESS:
        return state.withMutations((newState) => {
          const { buckets, all_items_count: totalErrorCounts = 0, total } = payload;
          buckets.sort((itemLeft, itemRight) => itemRight.count - itemLeft.count);
          const errors = OrderedSet(
            buckets.map((item) => ({
              name: item.name,
              count: item.count,
              items: item.items,
            })),
          );
          newState
            .set('totalErrorCounts', totalErrorCounts)
            .set('aggregatedErrors', errors)
            .set('aggregatedErrorsTotal', total);
        });
      case types.CLEANUP_TEST_ERROR:
        return initialState;
      case types.GET_TESTS_BY_ERROR.REQUEST:
        return state.setIn(['testsByError', meta.errorName, 'loading'], true);
      case types.GET_TESTS_BY_ERROR.FAILURE:
        return state.withMutations((newState) => {
          newState.setIn(['testsByError', meta.errorName, 'loading'], false);
          newState.setIn(['testsByError', meta.errorName, 'error'], error);
        });
      case types.GET_TESTS_BY_ERROR.SUCCESS:
        return state.withMutations((newState) => {
          newState.setIn(['testsByError', meta.errorName, 'data'], payload.items);

          newState.setIn(['testsByError', meta.errorName, 'loading'], false);
          newState.setIn(['testsByError', meta.errorName, 'error'], null);
        });
      case types.CHANGE_PAGE:
        return state.setIn(['pagination', 'current'], payload);
      default:
        return state;
    }
  };
  return { initialState, reducer };
};
